import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DeletePlayerInputClass;
function DeletePlayerInput() {
  if (DeletePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId) {
        this.e6p_1 = partyId;
        this.f6p_1 = playerId;
      }
      toString() {
        return 'DeletePlayerInput(partyId=' + this.e6p_1.toString() + ', playerId=' + this.f6p_1.toString() + ')';
      }
      hashCode() {
        var result = this.e6p_1.hashCode();
        result = imul(result, 31) + this.f6p_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePlayerInput()))
          return false;
        if (!this.e6p_1.equals(other.e6p_1))
          return false;
        if (!this.f6p_1.equals(other.f6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePlayerInput');
    DeletePlayerInputClass = $;
  }
  return DeletePlayerInputClass;
}
//region block: exports
export {
  DeletePlayerInput as DeletePlayerInput3nqh5he11jo1p,
};
//endregion

//# sourceMappingURL=DeletePlayerInput.mjs.map
